import React, { useState, useEffect } from "react";
import CustomTable from "../../../../customComponents/CustomTable";
// import './index.scss';
import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
import DownloadSVG from "./../../../../../Assets/icons/DownloadIconMIS.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import Loader from "../../../../customComponents/CustomLoader";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
// import ProductTable from './ProductTable';
import { FiDownload } from "react-icons/fi";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert";

const DailyStockUpload = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [filters, setFilters] = useState({});
  const [totalActive, setTotalActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const [formData, setFormData] = useState({});

  const [variantOptions, setVariantOptions] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);

  const [shouldFetch, setShouldFetch] = useState(false);


  useEffect(() => {
    fetchVariantOptions();
  }, []);

  const fetchVariantOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          batteryType: "N",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  useEffect(() => {
    fetchItemOptions();
  }, []);

  const fetchItemOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/item/ddlitem",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  // useEffect(() => {
  //   fetchProductList()
  // },[])

useEffect(() => {
  if (shouldFetch) {
    fetchProductList();
    setShouldFetch(false); // reset after fetch
  }
}, [shouldFetch]);

useEffect(() => {
  fetchProductList()
},[])

  const fetchProductList = async (page = 0, pageSize = 10) => {
    try {
      const allfilteredData = filters;

      setLoading(true);
      const response = await axiosInstance.post(
        "/inStock/daily-add-stock/list",
        {
          // orderBy: 'product_id desc',
          page,
          pageSize,
          searchText: searchTerm,
          variant_id: allfilteredData?.variantId
            ? allfilteredData?.variantId
            : null,
          stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
          // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
          // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
          startDate: formatDate(allfilteredData?.fromDate),
          endDate: formatDate(allfilteredData?.toDate),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize,
        itemtype_id:
          item.itemtype_id === 3
            ? "Vehicle"
            : item.itemtype_id === 1
              ? "Spare Part"
              : item.itemtype_id === 2
                ? "Accessories"
                : "--",
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductData = async () => {
    const allfilteredData = filters;
    const payload = {
      // business_partner_id: 1,
      // dealerId: dealerId || "",
      //   dealerId: allfilteredData?.dealerId? allfilteredData?.dealerId :null,
      //   // fromDate:"",
      //   // toDate:"",
      //   state_id:"",
      //   services_by:"",
      //   servicesValue_Id:"",
      //   orderBy:"po_id desc",
      //  toDate:"",
      // fromDate:"",
      // page: 0,
      // pageSize: 10,
      // searchText: "",
      // orderBy: "loginHistoryId desc",
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };
    console.log("filteresdata", payload);

    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/product/product-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      // setTableLoader(false)
      // const formattedData = response?.data?.data?.data.map((item, index) => ({
      //     ...item,
      //     item_name: item.item_name || "--",
      //     model_name: item.model_name || "--",
      //     variant_name: item.variant_name || "--",
      //     logInDateTime: item.logInDateTime
      //     ? new Date(item.logInDateTime)
      //         .toLocaleString("en-GB", { hour12: false }) // 24-hour format
      //         .replace(/\//g, "-") // Convert date separator to "-"
      //     : "--"

      // }))
      // const totalRecordsData = response?.data?.data?.totalRecords
      // setTotalRecords(totalRecordsData);

      // setVinNoData(formattedData)
    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post(
        "/product/product-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "product.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const TABLE_HEADERS = [
    "Item Type",
    "Model Name",
    "Color Name",
    "Variant Name",
    // "Item Name",
    "Quantity",
    // "Created On",
  ];

  const keyMapping = {
    "Item Type": "record_type",
    "Model Name": "model_name",
    "Color Name": "color_name",
    "Variant Name": "name",
    "Item Name": "item_name",
    Quantity: "liveQuantity",
    "Created On": "created_at",
  };
  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITPRODUCT}`, { state: { data: rowData } });
  };

  const StockUploadInputs = [
    {
      name: "itemType",
      label: "Item Type",
      placeholder: "Enter",
      type: "dropdown",
      options: [
        { value: "V", label: "Vehicle" },
        // { value: "A", label: "Accessories" },
        // { value: "S", label: "Spare Part" },
      ],
      required: true,
      gridClass: "col-lg-3",
      validation: { required: true },
    },
    ...(formData.itemType === "V"
      ? [
          {
            // name: "variant",
            name: "variant",
            label: "Variant",
            placeholder: "",
            type: "dropdown",
            options: variantOptions,
            required: true,
            gridClass: "col-lg-3",
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemType !== "V"
      ? [
          {
            name: "accessory",
            label: "Item Name",
            placeholder: "",
            type: "dropdown",
            options: accessoryOptions,
            required: true,
            gridClass: "col-lg-3",
            validation: { required: true },
          },
        ]
      : []),
    {
      name: "quantity",
      label: "Quantity",
      placeholder: "Enter Quantity",
      type: "number",
      required: true,
      gridClass: "col-lg-3",
      validation: {
        required: true,
        pattern: /^[1-9][0-9]*$/,
        message: "Please enter a positive number with no leading zeros",
      },
    },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      modelId: filterFormData?.modelId ? filterFormData?.modelId : null,
      variantId: filterFormData?.variantId ? filterFormData?.variantId : null,
      dealerId: filterFormData?.dealerId ? filterFormData?.dealerId : null,
      colorId: filterFormData?.colorId || null,
    });
  };

  const handleFormSubmit = async (formData) => {
    console.log("productformdata", formData);

    // Validate form before submission
    const errors = {};
    let isValid = true;

    StockUploadInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to add this item to stock?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      // const payload = {
      //   quantity: formData.quantity,
      //   item_id:
      //     formData.itemType === "V" ? formData.variant : formData.accessory,
      // };

      // const typeMap = {
      //   V: 3, // Vehicle
      //   S: 1, // Spare Part
      //   A: 2, // Accessories
      // };

      const payload = {
        quantity: parseInt(formData.quantity, 10),
        itemtype_id: formData.itemType,
        // itemtype_id: typeMap[formData.itemType] ?? null,
        ...(formData.itemType === "V"
          ? { variant_id: formData.variant }
          : { item_id: formData.accessory }),
      };

      const response = await axiosInstance.post("/inStock/daily-add-stock", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response:", response.data);

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Item added to stock successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("");
       setShouldFetch(true);
       setFormData({})
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      await showAlert({
        title: "Something went wrong",
        text: errorMessage,
        confirmButtonText: "OK",
      });
      setLoading(false);
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  return (
    <>
      <div>
          <div>
            <div className="OnboardManagamentContainer">
              <div className="OnboardManagamentbuttonContainer">
                <h5>Daily Stock Upload</h5>
              </div>
            </div>
            <div className="tableWrapper">
              <div className="admin-list-container">
                <div className="listsearchContainer">
                  <h4>Daily Stock Upload</h4>
                  <div>
                    
                  </div>
                </div>
              </div>
              <div className="form-container">
                      <span className="cust-det-title mt-2 mb-2">
                        Enter Stock Details
                      </span>
                      <DynamicForm
                        formConfig={StockUploadInputs}
                        formData={formData}
                        setFormData={setFormData}
                        validationErrors={validationErrors}
                        setValidationErrors={setValidationErrors}
                      />
                      <div className="btncontainer mt-3">
                        <button
                          onClick={() => {
                            handleFormSubmit(formData);
                          }}
                          className="submit-btn"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    {loading ? (
          <Loader />
        ) : (
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
              />
            )}
            </div>
          </div>
      </div>
    </>
  );
};

export default DailyStockUpload;
